
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { store,persistor } from './Redux/_helpers/store';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomLoader from './Components/Shared/CustomLoader';

//console.log = console.warn = console.error = console.info = console.clear = console.exception= () =>{}
ReactDOM.render(
  <React.StrictMode>
     <Provider store={store}>
         <PersistGate loading={"loading"} persistor={persistor}>
    <App />
    <CustomLoader />
    </PersistGate>
     </Provider>
    
  </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();





// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';

// import reportWebVitals from './reportWebVitals';
// import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/lib/integration/react';
// import { store,persistor } from './Redux/_helpers/store';
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import CustomLoader from './Components/Shared/CustomLoader';

// import ShipmentDetailsTransportationService from './Components/Pages/MarketPlace/ShipmentDetailsTransportationService';
// import TransportationServiceGS from './Components/Pages/GenericServices/TransportationServiceGS';
// import QuotationHistory from './Components/Pages/ContainerStatus/ContainerStatus';
// import CreateTransportationService from './Components/Pages/GenericServices/TransportationServiceGS';
// import RespondentTransportationService from './Components/Pages/MarketPlace/RespondentTransportationService';
// import RespondentRespTransportationServiceGS from './Components/Pages/GenericServices/RespondentTransportationServiceGS';

// import ServiceSelection from './Components/Pages/GenericServices/RespondentTransportationServiceGS';



 
// console.log = console.warn = console.error = console.info = console.clear = console.exception= () =>{}


// ReactDOM.render(
  
//   <React.StrictMode>
//      <Provider store={store}>
//          <PersistGate loading={"loading"} persistor={persistor}>
//     <CreateTransportationService/>
//     <CustomLoader />
//     </PersistGate>
//      </Provider>
    
//   </React.StrictMode>,
//   document.getElementById('root')
// );
// reportWebVitals();











// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';
// import './index.css';

// import RespondentTransportationService from './Components/Pages/MarketPlace/RespondentTransportationService';
// import QuotationDetails from './Components/Pages/MarketPlace/QuotationDetails';
// import QuotationDetailsGS from './Components/Pages/GenericServices/QuotationDetailsGS';
// import FilterRequestsGS from './Components/Pages/GenericServices/FilterRequestsGS';
// import UpdateServiceRequest from './Components/Pages/MarketPlace/UpdateServiceRequest';
// import UpdateServiceRequestGS from './Components/Pages/GenericServices/UpdateServiceRequestGS';
// import ShipmentDetailsTransportationService from './Components/Pages/MarketPlace/ShipmentDetailsTransportationService';
// ReactDOM.render(
//   <ShipmentDetailsTransportationService />,
//   document.getElementById('root') 
// );
